import React, { useEffect } from 'react';

import { Form, Space, Button } from 'antd';

import SPDynamicFormRender from 'components/base/SPDynamicFormRender';

import { useOrderList } from 'hooks/order-management/order-list';

import { JSONS } from 'jsons';

interface IComponentProps {
  enums: any
}
const SPSearchForm: React.FC<IComponentProps> = (props) => {
  const { enums } = props

  const [form] = Form.useForm();

  const searchButtonText = '搜索';
  const clearButtonText = '清空';

  const searchFormView = JSONS.orderManagement.orderList.searchFormView;

  const { searchFormReset, searchFormFinish } = useOrderList();

  const onReset = () => {
    form.resetFields();
    searchFormReset(form);
  };

  const onFinish = () => {
    searchFormFinish(form);
  }

  useEffect(() => {
    setTimeout(() => searchFormFinish(form), 100);
  }, [])

  return (
    <Form form={form}>
      <SPDynamicFormRender data={searchFormView} enums={enums} />
      <Form.Item>
        <Space>
          <Button type="primary" onClick={onFinish}>{searchButtonText}</Button>
          <Button onClick={onReset}>{clearButtonText}</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default SPSearchForm;


